(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["practice-profile-page"] && !window.DesignMode) return;
  try {
    

// Function to highlight the current day of the week
function highlightCurrentDay() {
  // Get current day of the week (0 = Sunday, 1 = Monday, etc.)
  const today = new Date().getDay();
  
  // Map days to corresponding data attributes
  const dayMapping = {
    0: 'sun', // Sunday
    1: 'mon', // Monday
    2: 'tue', // Tuesday
    3: 'wed', // Wednesday
    4: 'thu', // Thursday
    5: 'fri', // Friday
    6: 'sat'  // Saturday
  };
  
  // Remove existing selected class from all day cards
  const allDayCards = document.querySelectorAll('.day-card');
  allDayCards.forEach(card => {
    card.classList.remove('day-card--selected');
  });
  
  // Find the current day's card using data attribute and add the selected class
  const currentDayClass = dayMapping[today];
  const currentDayCard = document.querySelector(`[data-day="${currentDayClass}"]`);
  
  if (currentDayCard) {
    currentDayCard.classList.add('day-card--selected');
    console.log(`✅ Highlighted current day: ${currentDayClass}`);
  } else {
    console.warn(`❌ Could not find day card for: ${currentDayClass}`);
  }
}

// Run the function when the page loads
document.addEventListener('DOMContentLoaded', highlightCurrentDay);

// Optional: Update every minute to handle day changes (useful for testing or when page stays open overnight)
setInterval(highlightCurrentDay, 60000);
  
const Init = () => {
    console.log("🚀 PRACTICE PAGE FIXED VERSION STARTED");
    
    const apiBaseURL       = "https://dryeye-rescue-admin.vercel.app/api/graphql";
    const shopifyBaseURL   = "https://wholesale.dryeyerescue.com";
    const currentPathname  = document.location.pathname;
    const urlPattern       = "/pages/practice/";
    const hasPracticeID    = currentPathname.includes(urlPattern)
                            && currentPathname.split("/").length <= 4
                            && currentPathname.split("/")[3] !== "";
    const practiceID       = hasPracticeID ? currentPathname.split("/")[3] : null;

    console.log("📍 Practice ID detected:", practiceID);

    // Enhanced DOM element detection with detailed logging
    const diagnosticGetElement = (id, required = true) => {
        const element = document.getElementById(id);
        const status = element ? "✅ FOUND" : "❌ MISSING";
        console.log(`DOM Element ${id}: ${status}`);
        if (!element && required) {
            console.error(`🚨 CRITICAL: Required element '${id}' not found in DOM`);
        }
        return element;
    };

    const diagnosticGetElements = (selector, required = true) => {
        const elements = document.querySelectorAll(selector);
        const status = elements.length > 0 ? `✅ FOUND (${elements.length})` : "❌ MISSING";
        console.log(`DOM Elements '${selector}': ${status}`);
        if (elements.length === 0 && required) {
            console.error(`🚨 CRITICAL: Required elements '${selector}' not found in DOM`);
        }
        return elements;
    };

    console.log("\n🔍 CHECKING DOM ELEMENTS:");
    
    // Check all required DOM elements
    const practiceTitleDOM          = diagnosticGetElement("practice_title");
    const practiceImageDOM          = diagnosticGetElement("practice_image");
    const practiceAddressDOM        = diagnosticGetElement("practice_address");
    const practicePhoneDOM          = diagnosticGetElements(".practice_phone");
    const practiceWebsiteDOM        = diagnosticGetElements(".practice_website");
    const practiceAppointmentLinkDOM= document.querySelector(".practice_appointment_link");
    const practiceProviderPlusDOM   = diagnosticGetElement("practice_provider_plus", false);
    const practiceProviderDOM       = diagnosticGetElement("practice_provider", false);
    const practicePartnerDOM        = diagnosticGetElement("practice_partner", false);
    const practiceDoctorsContainerDOM  = diagnosticGetElement("practice_doctors_container");
    const practiceTreatmentsDOM     = diagnosticGetElement("practice_treatments");
    const practiceServicesDOM       = diagnosticGetElement("practice_services");
    const practiceTestsDOM          = diagnosticGetElement("practice_tests");
    const practiceInsurancesDOM     = diagnosticGetElement("practice_insurances");
    
    // Hours elements
    const practiceMonHoursDOM       = diagnosticGetElement("practice_mon_hours", false);
    const practiceTueHoursDOM       = diagnosticGetElement("practice_tue_hours", false);
    const practiceWedHoursDOM       = diagnosticGetElement("practice_wed_hours", false);
    const practiceThuHoursDOM       = diagnosticGetElement("practice_thu_hours", false);
    const practiceFriHoursDOM       = diagnosticGetElement("practice_fri_hours", false);
    const practiceSatHoursDOM       = diagnosticGetElement("practice_sat_hours", false);
    const practiceSunHoursDOM       = diagnosticGetElement("practice_sun_hours", false);
    
    // Social elements - FIXED: Removed duplicates
    const skeletonDOM               = diagnosticGetElements(".practices_skeleton", false);
    const tiersContainerDOM         = diagnosticGetElement("tiers-container", false);
    
    // Only inline social media elements (removed duplicates)
    const practiceFacebookInlineDOM     = diagnosticGetElement("practice_facebook_inline", false);
    const practiceInstagramInlineDOM    = diagnosticGetElement("practice_instagram_inline", false);
    const practiceTwitterInlineDOM      = diagnosticGetElement("practice_twitter_inline", false);

    console.log(`\n📊 DOM ELEMENTS SUMMARY:`);
    console.log(`- Skeleton elements found: ${skeletonDOM.length}`);
    console.log(`- Phone elements found: ${practicePhoneDOM.length}`);
    console.log(`- Website elements found: ${practiceWebsiteDOM.length}`);

    const fetchContent = async (action, payload) => {
      try {
        console.log(`🌐 Fetching ${action}...`);
        
        if (action==="getPractice") {
          const response = await fetch(apiBaseURL, {
            method:'POST', 
            headers:{'Content-Type':'application/json'},
            body: JSON.stringify({
              query: `query Practice($practiceId:Int!) { 
                practice(id:$practiceId) { 
                         id
                         name
                         gallery
                         address
                         phone
                         website
                         email
                         providerPlus
                         provider
                         partner
                         appointmentLink
                         doctors {
                           fullName,
                           image
                         } 
                         offerings { 
                           name,
                           type 
                         } 
                         insurances { 
                           name 
                         } 
                         openingHours{ 
                           mo 
                           tu 
                           we 
                           th 
                           fr 
                           sa 
                           su
                         }
                         latitude
                         longitude 
                         socialMedia { 
                           facebook 
                           twitter 
                           instagram 
                         } 
                         productsFromOrder
                       }
                     }`,
              variables:{ practiceId: Number(payload.id) }
            })
          });
          
          const result = await response.json();
          console.log("📥 GraphQL Response received:", result);
          
          if (result.errors) {
            console.error('🚨 GraphQL errors:', result.errors);
            return null;
          }
          
          const practice = result.data?.practice;
          console.log("✅ Practice data extracted:", practice ? "SUCCESS" : "FAILED");
          return practice;
        }
        
        if (action==="getShopifyProducts") {
          const url1 = `${shopifyBaseURL}/products.json?limit=250&page=1`;
          const url2 = `${shopifyBaseURL}/products.json?limit=250&page=2`;
          const [r1,r2] = await Promise.all([fetch(url1),fetch(url2)]);
          const j1=await r1.json(), j2=await r2.json();
          const products = [...(j1.products || []), ...(j2.products || [])];
          console.log(`✅ Shopify products loaded: ${products.length} items`);
          return products;
        }
      } catch (error) {
        console.error(`🚨 Error in fetchContent for ${action}:`, error);
        return null;
      }
    };

    const buildDoctors = (docs) => {
      console.log("\n👨‍⚕️ BUILDING DOCTORS SECTION");
      console.log("- Input doctors:", docs);
      console.log("- Doctors count:", docs?.length || 0);
      console.log("- Container element exists:", !!practiceDoctorsContainerDOM);

      if (!docs || !Array.isArray(docs) || docs.length === 0) {
        console.log('❌ No doctors data available');
        return false;
      }

      if (!practiceDoctorsContainerDOM) {
        console.error('🚨 Doctors container DOM element not found');
        return false;
      }

      console.log('✅ Building doctors section with', docs.length, 'doctors');

      const doctorsHTML = docs.map((d, index) => {
        const doctorName = d.fullName || 'Unknown Doctor';
        let imageUrl = 'https://cdn.shopify.com/s/files/1/0509/4467/1902/files/avatar.svg';
        
        if (d.image) {
          imageUrl = `https://dryeyerescue-assets.s3.amazonaws.com/practice-doctors/${d.image}`;
        }

        console.log(`- Doctor ${index + 1}: ${doctorName}, Image: ${imageUrl}`);

        return `
          <div class="doctor-card">
            <img class="doctor-avatar" src="${imageUrl}" alt="${doctorName}" onerror="this.src='https://cdn.shopify.com/s/files/1/0509/4467/1902/files/avatar.svg'; console.log('Doctor image failed to load: ${imageUrl}')"/>  
            <h4 class="doctor-name">${doctorName}</h4>
          </div>
        `;
      }).join('');

      const finalHTML = `
        <h2 class="section-title">Our Doctors</h2>
        <div class="doctors-carousel">
          ${doctorsHTML}
        </div>
      `;

      console.log("📝 Generated doctors HTML (first 200 chars):", finalHTML.substring(0, 200) + "...");

      practiceDoctorsContainerDOM.innerHTML = finalHTML;

      console.log('✅ Doctors section built successfully');
      
      // Verify the HTML was actually inserted
      setTimeout(() => {
        const insertedCards = practiceDoctorsContainerDOM.querySelectorAll('.doctor-card');
        console.log(`🔍 Verification: Found ${insertedCards.length} doctor cards in DOM`);
      }, 100);

      return true;
    };

    const buildPracticeOrService = (items, dom, sectionName) => {
      console.log(`\n🏥 BUILDING ${sectionName.toUpperCase()} SECTION`);
      console.log(`- Input items:`, items);
      console.log(`- Items count: ${items?.length || 0}`);
      console.log(`- DOM element exists: ${!!dom}`);

      if (!items || !Array.isArray(items) || items.length === 0) {
        console.log(`❌ No ${sectionName} data available`);
        return false;
      }

      if (!dom) {
        console.error(`🚨 ${sectionName} DOM element not found`);
        return false;
      }

      console.log(`✅ Building ${sectionName} section with ${items.length} items`);

      const itemsHTML = items.map((item, index) => {
        console.log(`- ${sectionName} ${index + 1}: ${item}`);
        return `<li>${item}</li>`;
      }).join('');

      const finalHTML = `<ul class="info-list">${itemsHTML}</ul>`;
      
      console.log(`📝 Generated ${sectionName} HTML (first 200 chars):`, finalHTML.substring(0, 200) + "...");

      // FIXED: Show the container and populate it
      dom.style.display = 'block';
      dom.innerHTML = finalHTML;

      console.log(`✅ ${sectionName} section built successfully`);
      
      // Verify the HTML was actually inserted
      setTimeout(() => {
        const insertedItems = dom.querySelectorAll('li');
        console.log(`🔍 Verification: Found ${insertedItems.length} ${sectionName} items in DOM`);
      }, 100);

      return true;
    };

    const formatURL = u => u && u.match(/^https?:\/\//)?u:`https://${u}`;

    const updateUI = (practice, allProducts) => {
      console.log("\n🎨 UPDATING UI WITH PRACTICE DATA");
      
      if (!practice) {
        console.error('🚨 No practice data available for UI update');
        return;
      }

      console.log('📊 Practice data structure:', {
        name: practice.name,
        doctors: practice.doctors?.length || 0,
        offerings: practice.offerings?.length || 0,
        insurances: practice.insurances?.length || 0,
        gallery: practice.gallery?.length || 0,
      });

      const { 
        name, gallery, address, phone, website, email, providerPlus, provider, partner,
        appointmentLink, latitude, longitude, doctors, offerings, insurances,
        openingHours, socialMedia, productsFromOrder 
      } = practice;

      // Basic info updates (title, image, etc.)
      console.log("\n📝 Updating basic information...");
      
      if(name && practiceTitleDOM) {
        practiceTitleDOM.innerText = name;
        console.log("✅ Title updated:", name);
      }

      if(address && practiceAddressDOM) {
        practiceAddressDOM.innerText = address;
        console.log("✅ Address updated:", address);
      }

      // MAIN IMAGE
      if (gallery && Array.isArray(gallery) && gallery.length && practiceImageDOM) {
        const imageUrl = `https://dryeyerescue-assets.s3.amazonaws.com/practices/gallery/${gallery[0]}`;
        practiceImageDOM.src = imageUrl;
        practiceImageDOM.alt = (name || 'Practice') + " image";
        console.log("✅ Main image updated:", imageUrl);
      }

      // Phone updates
      if(phone){
        practicePhoneDOM.forEach((a, index) => {
          a.href = "tel:"+phone;
          const txt = a.classList.contains("cta-button") ? "Call Now" : phone;
          const span = a.querySelector("span:last-child");
          if(span) span.innerText = txt;
          console.log(`✅ Phone link ${index + 1} updated:`, phone);
        });
      }

      // Website updates
      if(website){
        const url = formatURL(website);
        practiceWebsiteDOM.forEach((a, index) => {
          a.href = url;
          console.log(`✅ Website link ${index + 1} updated:`, url);
        });
      }

      // Email update
      if(email){
        const emailEl = document.querySelector(".practice_email");
        if (emailEl) {
          const emailSpan = emailEl.querySelector("span:last-child");
          if (emailSpan) emailSpan.innerText = email;
          emailEl.href = `mailto:${email}`;
          console.log("✅ Email updated:", email);
        }
      }

      // Appointment link
      if(appointmentLink && practiceAppointmentLinkDOM){
        practiceAppointmentLinkDOM.style.display="inline-flex";
        practiceAppointmentLinkDOM.href = appointmentLink;
        console.log("✅ Appointment link updated:", appointmentLink);
      }

      // Handle social media - FIXED: Only inline social media
      const handleSocialMedia = (platform, inlineElement) => {
        const url = socialMedia?.[platform];
        if (url) {
          const handler = () => window.open(url, '_blank');
          if (inlineElement) {
            inlineElement.addEventListener("click", handler);
            console.log(`✅ ${platform} social media updated:`, url);
          }
        } else {
          if (inlineElement) inlineElement.remove();
          console.log(`❌ No ${platform} URL, removing element`);
        }
      };

      handleSocialMedia('facebook', practiceFacebookInlineDOM);
      handleSocialMedia('instagram', practiceInstagramInlineDOM);
      handleSocialMedia('twitter', practiceTwitterInlineDOM);

      // Badges
      if(!providerPlus && practiceProviderPlusDOM) {
        practiceProviderPlusDOM.remove();
        console.log("❌ Removed Provider+ badge");
      }
      if(!provider && practiceProviderDOM) {
        practiceProviderDOM.remove();
        console.log("❌ Removed Provider badge");
      }
      if(!partner && practicePartnerDOM) {
        practicePartnerDOM.remove();
        console.log("❌ Removed Partner badge");
      }

      // DOCTORS SECTION - This is critical
      console.log("\n👨‍⚕️ PROCESSING DOCTORS...");
      if (doctors && Array.isArray(doctors) && doctors.length > 0) {
        console.log("✅ Doctors data is valid, building section...");
        buildDoctors(doctors);
      } else {
        console.log('❌ No doctors available or invalid data');
        console.log('- doctors exists:', !!doctors);
        console.log('- doctors is array:', Array.isArray(doctors));
        console.log('- doctors length:', doctors?.length);
      }

      // OFFERINGS PROCESSING - This is critical
      console.log("\n🏥 PROCESSING OFFERINGS...");
      console.log("- offerings exists:", !!offerings);
      console.log("- offerings is array:", Array.isArray(offerings));
      console.log("- offerings length:", offerings?.length);

      let services = [], treatments = [], equipment = [];
      
      if (offerings && Array.isArray(offerings)) {
        console.log("✅ Offerings data is valid, filtering...");
        
        services   = offerings.filter(o => o && o.type === "SERVICE").map(o => o.name).filter(Boolean);
        treatments = offerings.filter(o => o && o.type === "TREATMENT").map(o => o.name).filter(Boolean);
        equipment  = offerings.filter(o => o && o.type === "EQUIPMENT").map(o => o.name).filter(Boolean);

        console.log("- Services found:", services.length, services.slice(0, 3));
        console.log("- Treatments found:", treatments.length, treatments.slice(0, 3));
        console.log("- Equipment found:", equipment.length, equipment.slice(0, 3));
      } else {
        console.log('❌ Offerings data is invalid');
      }

      // INSURANCES PROCESSING - This is critical
      console.log("\n🏥 PROCESSING INSURANCES...");
      let insurNames = [];
      if (insurances && Array.isArray(insurances)) {
        insurNames = insurances.map(i => i && i.name).filter(Boolean);
        console.log("✅ Insurances found:", insurNames.length, insurNames.slice(0, 3));
      } else {
        console.log('❌ No valid insurances data');
      }

      // BUILD SECTIONS - This is where the magic happens
      console.log("\n🏗️ BUILDING CONTENT SECTIONS...");

      console.log("📝 Building services section...");
      if (!buildPracticeOrService(services, practiceServicesDOM, 'services')) {
        console.log("❌ Services section build failed, removing element");
        if (practiceServicesDOM) {
          const parentSection = practiceServicesDOM.closest(".content-section");
          if (parentSection) parentSection.remove();
        }
      }

      console.log("📝 Building treatments section...");
      if (!buildPracticeOrService(treatments, practiceTreatmentsDOM, 'treatments')) {
        console.log("❌ Treatments section build failed, removing element");
        if (practiceTreatmentsDOM) {
          const parentSection = practiceTreatmentsDOM.closest(".content-section");
          if (parentSection) parentSection.remove();
        }
      }

      console.log("📝 Building equipment section...");
      if (!buildPracticeOrService(equipment, practiceTestsDOM, 'equipment')) {
        console.log("❌ Equipment section build failed, removing element");
        if (practiceTestsDOM) {
          const parentSection = practiceTestsDOM.closest(".content-section");
          if (parentSection) parentSection.remove();
        }
      }

      console.log("📝 Building insurances section...");
      if (!buildPracticeOrService(insurNames, practiceInsurancesDOM, 'insurances')) {
        console.log("❌ Insurances section build failed, removing element");
        if (practiceInsurancesDOM) {
          const parentSection = practiceInsurancesDOM.closest(".content-section");
          if (parentSection) parentSection.remove();
        }
      }

      // Hours processing
      console.log("\n🕐 PROCESSING HOURS...");
      const oh = openingHours || {};
      if(!Object.values(oh).some(Boolean)){
        console.log("❌ No hours data available");
      } else {
        console.log("✅ Hours data available, updating...");
        const updateHours = (element, hours, day) => {
          if (element && hours) {
            element.innerText = hours;
            console.log(`- ${day}: ${hours}`);
          }
        };

        updateHours(practiceMonHoursDOM, oh.mo, "Monday");
        updateHours(practiceTueHoursDOM, oh.tu, "Tuesday");
        updateHours(practiceWedHoursDOM, oh.we, "Wednesday");
        updateHours(practiceThuHoursDOM, oh.th, "Thursday");
        updateHours(practiceFriHoursDOM, oh.fr, "Friday");
        updateHours(practiceSatHoursDOM, oh.sa, "Saturday");
        
        if(practiceSunHoursDOM) {
          practiceSunHoursDOM.innerText = (oh.su || "CLOSED");
          if(!oh.su) practiceSunHoursDOM.classList.add("day-closed");
          console.log("- Sunday:", oh.su || "CLOSED");
        }
      }

      // Remove skeletons AFTER all content is built
      console.log("\n🧹 CLEANING UP SKELETONS...");
      setTimeout(() => {
        let skeletonsRemoved = 0;
        skeletonDOM.forEach(s => {
          try {
            s.remove();
            skeletonsRemoved++;
          } catch (e) {
            console.warn('Could not remove skeleton element:', e);
          }
        });
        console.log(`✅ Removed ${skeletonsRemoved} skeleton elements`);
      }, 200);

      console.log('\n🎉 UI UPDATE COMPLETED SUCCESSFULLY');
      
      // Final verification
      setTimeout(() => {
        console.log("\n🔍 FINAL VERIFICATION:");
        console.log("- Doctor cards in DOM:", document.querySelectorAll('.doctor-card').length);
        console.log("- Service items in DOM:", practiceServicesDOM?.querySelectorAll('li').length || 0);
        console.log("- Treatment items in DOM:", practiceTreatmentsDOM?.querySelectorAll('li').length || 0);
        console.log("- Equipment items in DOM:", practiceTestsDOM?.querySelectorAll('li').length || 0);
        console.log("- Insurance items in DOM:", practiceInsurancesDOM?.querySelectorAll('li').length || 0);
        
        // IMPORTANT: Re-run the day highlighting after all content is loaded
        console.log("🔄 Re-highlighting current day after content load...");
        highlightCurrentDay();
      }, 300);
    };

    // Main execution with enhanced logging
    (async () => {
      if (!practiceID) {
        console.error('🚨 No practice ID found in URL');
        return;
      }

      console.log(`\n🚀 STARTING MAIN EXECUTION FOR PRACTICE ID: ${practiceID}`);

      try {
        const practice = await fetchContent("getPractice", { id: practiceID });
        const shopifyProds = await fetchContent("getShopifyProducts");
        
        if (practice) {
          console.log('✅ Practice data loaded successfully, updating UI...');
          updateUI(practice, shopifyProds);
        } else {
          console.error('🚨 Failed to load practice data');
        }
      } catch (error) {
        console.error('🚨 Error in main execution:', error);
      }
    })();
};

// Enhanced initialization with error catching
try {
  document.addEventListener('DOMContentLoaded', () => {
    console.log("📄 DOM Content Loaded, initializing practice page...");
    Init();
  });
} catch (error) {
  console.error("🚨 Error during initialization:", error);
}

  } catch(e) { console.error(e); }
})();
})();
